import { Editor as EditorComponent } from '@tinymce/tinymce-react';
import { Paper, makeStyles, createStyles, Theme } from '@material-ui/core';
import React, { FC, EventHandler } from 'react';
import { TINY_API_KEY } from 'Resources/Config';

export interface EditorProps {
    initialValue?: string,
    onChangeValue?: EventHandler<any>;
}

const Editor: FC<EditorProps> = ({ initialValue, onChangeValue }) => {
    const classes = useStyles();
    return (
        <Paper className={classes.formContainer} >
            <EditorComponent
                apiKey={TINY_API_KEY}
                init={{
                    content_css: 'https://cdn.jsdelivr.net/gh/garbage-value/cdns/gv-tiny-mce.css',
                    height: "80%",
                    plugins: 'link image code fullscreen table codesample hr lists visualblocks preview',
                    toolbar: 'fullscreen undo redo | preview visualblocks numlist bullist bold italic | alignleft aligncenter alignright hr | codesample code | link image | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
                    codesample_languages: [
                        { text: 'C', value: 'c' },
                        { text: 'C++', value: 'csharp' },
                        { text: 'Java', value: 'java' },
                        { text: 'JavaScript', value: 'javascript' },
                        { text: 'Typescript', value: 'typescript' },
                        { text: 'YAML', value: 'yaml' }
                    ],
                    style_formats: [
                        {
                            title: 'Containers', items: [
                                { title: 'section', block: 'section', wrapper: true, merge_siblings: false },
                                { title: 'article', block: 'article', wrapper: true, merge_siblings: false },
                                { title: 'blockquote', block: 'blockquote', wrapper: true },
                                { title: 'hgroup', block: 'hgroup', wrapper: true },
                                { title: 'aside', block: 'aside', wrapper: true },
                                { title: 'figure', block: 'figure', wrapper: true },
                                { title: 'figcaption', block: 'figcaption', wrapper: true }
                            ]
                        }
                    ],
                }}
                initialValue={initialValue || ''}
                onChange={onChangeValue}
            />
        </Paper>
    )
}
const useStyles = makeStyles<Theme>((theme) => {
    return (createStyles({
        formContainer: {
            padding: 24,
            borderRadius: 4,
            marginBottom: 16,
            '& .tox.tox-tinymce': {
                minHeight: '500px !important'
            }
        }
    }))
})
export default Editor;